import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

export default function Immeubles() {
  const [immeubles, setImmeubles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);

  const [form, setForm] = useState({
    nom: "",
    adresse: "",
    ville: "",
    pays: "RDC",
    latitude: "",
    longitude: "",
    telephone: "",
    email: ""
  });

  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await api.get("/immeubles");
      setImmeubles(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const createImmeuble = async () => {
    try {

      await api.post("/immeubles", form);

      setCreating(false);

      load();

    } catch (err) {
      console.error(err);
      alert("Erreur lors de la création");
    }
  };

  const toggleImmeuble = async (id) => {
    try {
      await api.patch(`/immeubles/${id}/toggle`);
      await load();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "25px",
          flexWrap: "wrap",
          gap: "10px"
        }}
      >
        <div>
          <h1
            style={{
              margin: 0,
              fontSize: "28px",
              fontWeight: "700"
            }}
          >
            🏢 Gestion des immeubles
          </h1>

          <p
            style={{
              color: "#666",
              marginTop: "6px"
            }}
          >
            Gérez vos résidences et leurs localisations.
          </p>
        </div>

        <button
          onClick={() => {
            setForm({
              nom: "",
              adresse: "",
              ville: "",
              pays: "RDC",
              latitude: "",
              longitude: "",
              telephone: "",
              email: ""
            });

            setCreating(true);
          }}
          style={{
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            padding: "12px 18px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          ➕ Nouvel immeuble
        </button>
      </div>

      {/* LOADING */}
      {loading && (
        <p>Chargement...</p>
      )}

      {/* LISTE */}
      {!loading && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))",
            gap: "20px"
          }}
        >
          {immeubles.map((i) => (
            <div
              key={i.id}
              style={{
                background: "#fff",
                borderRadius: "18px",
                padding: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,.08)"
              }}
            >
              <h2
                style={{
                  marginTop: 0,
                  marginBottom: "12px",
                  fontSize: "22px"
                }}
              >
                🏢 {i.nom}
              </h2>

              <p
                style={{
                  fontWeight: "bold",
                  color: i.actif ? "green" : "red"
                }}
              >
                {i.actif ? "🟢 Actif" : "🔴 Désactivé"}
              </p>

              <p style={{ margin: "6px 0" }}>
                📍 {i.adresse || "Adresse non renseignée"}
              </p>

              <p style={{ margin: "6px 0", color: "#666" }}>
                🌍 {i.ville}, {i.pays}
              </p>

              <hr style={{ margin: "15px 0" }} />

                <p style={{ margin: "6px 0" }}>
                  🏠 <strong>{i.nb_appartements}</strong> logements
                </p>

                <p style={{ margin: "6px 0" }}>
                  🟢 <strong>{i.libres || 0}</strong> libres
                </p>

                <p style={{ margin: "6px 0" }}>
                  🟡 <strong>{i.reserves || 0}</strong> réservés
                </p>

                <p style={{ margin: "6px 0" }}>
                  🔴 <strong>{i.occupes || 0}</strong> occupés
                </p>

                <p style={{ margin: "6px 0" }}>
                  💰 <strong>
                    {Number(i.revenus || 0).toLocaleString()}
                  </strong> $
                </p>

                <div
                  style={{
                    marginTop: "10px",
                    fontWeight: "bold",
                    color: "#2563eb"
                  }}
                >
                  📈 Occupation : {
                    Number(i.nb_appartements) > 0
                      ? Math.round(
                          (Number(i.occupes || 0) * 100) /
                          Number(i.nb_appartements)
                        )
                      : 0
                  }%
                </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "15px"
                }}
              >
                <button
                  onClick={() => navigate(`/immeubles/${i.id}`)}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                >
                  Voir les détails
                </button>

                {isAdmin && (
                  <button
                    onClick={() => toggleImmeuble(i.id)}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      cursor: "pointer"
                    }}
                  >
                    {i.actif ? "Désactiver" : "Réactiver"}
                  </button>
                )}

              </div>
            </div>
          ))}
        </div>
      )}

      {creating && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "20px",
              width: "95%",
              maxWidth: "700px",
              maxHeight: "90vh",
              overflowY: "auto"
            }}
          >
            <h2>🏢 Nouvel immeuble</h2>

            <div
              style={{
                display: "grid",
                gap: "12px"
              }}
            >
              <input
                placeholder="Nom"
                value={form.nom}
                onChange={(e) =>
                  setForm({
                    ...form,
                    nom: e.target.value
                  })
                }
              />

              <input
                placeholder="Adresse"
                value={form.adresse}
                onChange={(e) =>
                  setForm({
                    ...form,
                    adresse: e.target.value
                  })
                }
              />

              <input
                placeholder="Ville"
                value={form.ville}
                onChange={(e) =>
                  setForm({
                    ...form,
                    ville: e.target.value
                  })
                }
              />

              <input
                placeholder="Pays"
                value={form.pays}
                onChange={(e) =>
                  setForm({
                    ...form,
                    pays: e.target.value
                  })
                }
              />

              <input
                placeholder="Latitude"
                value={form.latitude}
                onChange={(e) =>
                  setForm({
                    ...form,
                    latitude: e.target.value
                  })
                }
              />

              <input
                placeholder="Longitude"
                value={form.longitude}
                onChange={(e) =>
                  setForm({
                    ...form,
                    longitude: e.target.value
                  })
                }
              />

              <input
                placeholder="Téléphone"
                value={form.telephone}
                onChange={(e) =>
                  setForm({
                    ...form,
                    telephone: e.target.value
                  })
                }
              />

              <input
                placeholder="Email"
                value={form.email}
                onChange={(e) =>
                  setForm({
                    ...form,
                    email: e.target.value
                  })
                }
              />
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px"
              }}
            >
              <button
                onClick={() => setCreating(false)}
              >
                Annuler
              </button>

              <button
                onClick={createImmeuble}
              >
                Créer
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}